/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Quota_Monthly_Credit_OneInputs */

const fr_membership_quota_monthly_credit_one = /** @type {(inputs: Membership_Quota_Monthly_Credit_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 cours / mois (Crossfit ou Hyrox)`)
};

/**

* @param {Membership_Quota_Monthly_Credit_OneInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_quota_monthly_credit_one = /** @type {((inputs?: Membership_Quota_Monthly_Credit_OneInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Quota_Monthly_Credit_OneInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_quota_monthly_credit_one(inputs)
});